import {
  defaultSettings,
} from '@components/Widgets/_contentItems/_baseTemplate'

const fortuneWheelPrizeDefaultTemplate = {
  id: '',
  label: 'T-Shirt',
  value: '',
  weight: 10,
}

const prizesTemplate = {
  label: [
    'Coffee Mug',
    'Gift Card',
    'T-Shirt',
    'Keychain',
    'Discount',
    'Backpack',
    'Notebook',
    'Pen Set',
    'Headphones',
    'Speaker',
    'Tickets',
    'Voucher',
  ],
  value: [
    'CODE-COFFEE-MUG',
    'CODE-GIFT-CARD',
    'CODE-T-SHIRT',
    'CODE-KEYCHAIN',
    'CODE-DISCOUNT-VOUCHER',
    'CODE-BACKPACK',
    'CODE-NOTEBOOK',
    'CODE-PEN-SET',
    'CODE-HEADPHONES',
    'CODE-BLUETOOTH-SPEAKER',
    'CODE-MOVIE-TICKETS',
    'CODE-TRAVEL-VOUCHER',
  ],
}

const defaultStyling = {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: '400',
    color: 'rgb(255, 255, 255)',
    backgroundColor: 'rgb(252,118,106)',
    secondaryBackgroundColor: 'rgb(91,132,177)',
    justifyContent: 'center',
    borderRadius: '5px',
    borderWidth: '2px',
    borderColor: 'rgb(0, 0, 0)',
  }

const fortuneWheelWidgetDefaultTemplate = {
  id: '',
  type: 'wheel',
  category: 'hidden',
  content: {
    prizes: (() => {
      const prizesArr = []
      prizesTemplate.label.forEach((prize, index) => {
        const customPrize = JSON.parse(
          JSON.stringify(fortuneWheelPrizeDefaultTemplate))
        customPrize.id = index
        customPrize.label = prize
        customPrize.value = prizesTemplate.value[index]
        prizesArr.push(customPrize)
      })

      return prizesArr
    })(),
  },
  settings: {
    ...defaultSettings,
  },
  /*  Keep the styling even in flattened json structure cause vue ease of use */
  styling: { ...defaultStyling },
}

export { fortuneWheelWidgetDefaultTemplate, fortuneWheelPrizeDefaultTemplate, defaultStyling }
